'use strict';

var React = require('react');

var SvgMarketingMajor = function SvgMarketingMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.293 10.293a1 1 0 0 1 1.058-.23l8 3a1 1 0 0 1-.108 1.907l-3.418.855-.855 3.418a1 1 0 0 1-1.906.108l-3-8a1 1 0 0 1 .229-1.058Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6c1.354 0 2.499.897 2.872 2.13l2.127.79a5 5 0 1 0-5.078 5.08l-.792-2.128a3.001 3.001 0 0 1 .871-5.872Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66 15.97a7 7 0 1 1 6.31-6.31l1.925.722a9 9 0 1 0-7.513 7.513l-.723-1.926Z"
  }));
};

exports.SvgMarketingMajor = SvgMarketingMajor;
